import careConfig from "@careConfig";
import { Link } from "raviger";
import { useTranslation } from "react-i18next";

export const AuthHero = () => {
  const { t } = useTranslation();
  return (
    <section className="login-hero relative flex flex-col justify-between gap-12 p-8 md:w-1/2 md:p-14 lg:p-20">
      <a
        href="https://macarepolyclinic.com/"
        className="w-fit rounded-xl bg-white p-4"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={careConfig.mainLogo?.dark}
          alt={careConfig.appName}
          className="w-64 max-w-full"
        />
      </a>
      <div className="max-w-lg space-y-6 py-8">
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-sky-200">
          {t("macare_workspace")}
        </p>
        <h1 className="text-4xl font-semibold leading-tight tracking-tight text-white lg:text-5xl">
          {t("macare_headline")}
        </h1>
        <p className="text-lg leading-relaxed text-sky-100">
          {t("macare_description")}
        </p>
        <div className="h-1 w-16 rounded-full bg-lime-400" />
      </div>
      <div className="flex flex-wrap items-center gap-4 text-sm text-sky-100">
        <span>{t("macare_tagline")}</span>
        <Link href="/licenses" className="text-xs underline underline-offset-4">
          {t("third_party_software_licenses")}
        </Link>
      </div>
    </section>
  );
};
